require('./accountDebits.scss');

const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
const { connect } = require('react-redux');
// @ actions
const {
    changeTab,
    requestAccountDebits
} = require('actions/accountDebits');
// @ commons
const { formatText } = require('core/i18n').i18n;
const TabbedBox = require('components/commons/tabbedBox/tabbedBox');
// @ components
const AccountDebitsHeader = require('./accountDebitsHeader/accountDebitsHeader');
const AuthorizationsTable = require('./authorizationsTable/authorizationsTable');
const ReceiptsTable = require('./receiptsTable/receiptsTable');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { EmptyState } = require('commonsComponents/emptyState');

class AccountDebits extends React.PureComponent {
    constructor(props){
        super(props);
        this.clearFilters = this.clearFilters.bind(this);
    }

    componentDidMount() {
        const { immAccount } = this.props;
        const accountId = immAccount.get('accountId');
        const contractNumber = immAccount.get('newContractNumber');
        const contractProduct = immAccount.get('newProduct');
        this.props.requestAccountDebits(accountId, contractNumber, contractProduct);
    }

    componentDidUpdate() {
        const { immAccount, immAuthorizations } = this.props;
        const accountId = immAccount.get('accountId');
        if (!immAuthorizations.get(accountId)){
            const contractNumber = immAccount.get('newContractNumber');
            const contractProduct = immAccount.get('newProduct');
            this.props.requestAccountDebits(accountId, contractNumber, contractProduct);
        }
    }

    buildNotFound() {
        return (
            <div className="account-debits__not-found" >
                <EmptyState primaryText={formatText('accountDebits-notFound')} iconType="noitems-banking"/>
            </div>
        );
    }

    handleChangeTab = (tab) => {
        this.props.changeTab(tab)
    }

    requestAccountDebits() {
        const { immAccount } = this.props;
        const accountId = immAccount.get('accountId');
        const contractNumber = immAccount.get('newContractNumber');
        const contractProduct = immAccount.get('newProduct');
        this.props.requestAccountDebits(accountId, contractNumber, contractProduct);
    }

    clearFilters(){
        this.requestAccountDebits();
    }

    renderAuthorizations = (immAccount, immAccounts, accountId) => {
        return (
            <div>
                <AccountDebitsHeader
                    immAccount={immAccount}
                    immAccounts={immAccounts}
                    clearFilters={this.clearFilters}
                />
                <AuthorizationsTable accountId={accountId} />
            </div>
        )
    }

    renderReceipts = (immAccount, immAccounts, accountId) => {
        return (
            <div>
                <AccountDebitsHeader
                    immAccount={immAccount}
                    immAccounts={immAccounts}
                    clearFilters={this.clearFilters}
                />
                <ReceiptsTable accountId={accountId} />
            </div>
        )
    }

    render() {
        const { immAccount, immAccounts, immAccountDebits } = this.props;
        const accountId = immAccount.get('accountId');
        const activeTab = immAccountDebits.get('activeTab');

        const tabs = [
            { content: this.renderReceipts(immAccount, immAccounts, accountId) },
            { content: this.renderAuthorizations(immAccount, immAccounts, accountId) }
        ];
        return (
            <OKSectionBox>
                <div className="account-debits">
                    <TabbedBox
                        onTabSelection={this.handleChangeTab}
                        activeTab={activeTab}
                        id="accountDebitsTabs"
                        left={true}
                        tabs={tabs}
                    />
                </div>
            </OKSectionBox>
        );
    }
}

AccountDebits.propTypes = {
    changeTab: PropTypes.func.isRequired,
    immAccount: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immAccountDebits: PropTypes.object.isRequired,
    immAuthorizations: PropTypes.object.isRequired,
    requestAccountDebits: PropTypes.func.isRequired
};

module.exports.constructor = AccountDebits;
module.exports.AccountDebits = connect(
    state => ({
        immAccountDebits: state.accountDebits,
        immAuthorizations: state.authorizations
    }), {
        changeTab: changeTab,
        requestAccountDebits: requestAccountDebits
    })(AccountDebits);
